module.exports = __webpack_public_path__ + "img/et.183f3604.svg";